import React from 'react';
import { FaChevronRight, FaHandPaper, FaRegTrashAlt, FaFlag } from 'react-icons/fa';

interface OptionsDrawerContentProps {
    handleDelete: () => void;
    handleBlock: () => void;
    handleReport: () => void;
}

const OptionsDrawerContent: React.FC<OptionsDrawerContentProps> = ({ handleDelete, handleBlock, handleReport }) => {


    return (
        <div style={{
            borderRadius: "1rem 1rem 0 0",
          }} className="p-4 px-1 bg-white w-full m-0">
            <h2 className="text-lg font-semibold mb-4 text-center text-black">Options</h2>
            <div className="flex flex-col bg-gray-100 rounded-2xl">
                <button
                    onClick={handleDelete}
                    className=" flex items-center p-4 border-b border-gray-100 w-full text-left text-black  text-base"
                >
                    <span className="mr-3 p-2 bg-gray-300/80 rounded-full text-center">
                        <FaRegTrashAlt className="text-black size-3" />
                    </span>
                    <span>Delete message</span>
                    <span className="ml-auto">
                        <FaChevronRight className="text-gray-400 size-4" />
                    </span>
                </button>
                <button
                    onClick={handleBlock}
                    className="flex items-center p-4 border-b border-gray-100 w-full text-left text-red-600  text-base"
                >
                    
                    <span className="mr-3 p-2 bg-gray-300/80 rounded-full text-center">
                        <FaHandPaper className="text-red-600 size-3" />
                    </span>
                    <span>Block sender</span>
                    <span className="ml-auto">
                        <FaChevronRight className="text-gray-400 size-4" />
                    </span>
                </button>
                <button
                    onClick={handleReport}
                    className="flex items-center p-4 w-full text-left text-red-600 ftext-base"
                >
                    <span className="mr-3 p-2 bg-gray-300/80 rounded-full text-center">
                        <FaFlag className="text-red-600 size-3" />
                    </span>
                    {/* <span className="mr-3">🚩</span> */}
                    <span>Report message</span>
                    <span className="ml-auto">
                        <FaChevronRight className="text-gray-400 size-4" />
                    </span>
                </button>
            </div>
        </div>
    );
};

export default OptionsDrawerContent;